import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconExclamationTriangle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconExclamationTriangle"><Path fillRule="evenodd" clipRule="evenodd" d="M0.742188 19.9997L11.9989 1.04102L23.2557 19.9997H0.742188ZM13 8.99976V13.9998H11V8.99976H13ZM11 14.9998H13V16.9998H11V14.9998Z" fill="currentColor"/></CentralIconBase>;
});

export default IconExclamationTriangle;
